import React, { useState, useContext, useEffect } from "react";
import Modal from "../../../../../common/Modal";
import {
  MenteeInfoContainer,
  MenteeImage,
  Image,
  MenteeInfo,
  MenteeName,
  MenteeRole,
  Suggestions,
  HeadText,
  MatchMakingSliderOuter,
  NoMatchedText,
  NoMatchContainer,
  IgnoreSuggestion,
  IgnoreText,
} from "./style";
import MatchMakingSlider from "./MatchMakingSlider";
import { useParams } from "react-router-dom";
import { Context } from "../../../../../Store";
import callAPI from "../../../../../api/apiCaller";
import Icon from "../../../../../common/Icon";
import Loading from "../../../../../common/Loading";

const MatchMaking = ({
  mentee,
  closeModal,
  setOpenReassignModal,
  setClickedMentee,
  matchedParticipants,
  setMatchedParticipants
}) => {
  const { dispatch } = useContext(Context);
  const params = useParams();
  const [matchedMentors, setMatchedMentors] = useState([]);
  const [loading, setLoading] = useState([]);
  const [matchModal, setMatchModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const getMatchedMentors = () => {
    setLoading(true);
    callAPI(dispatch, "getMatchMentors", {
      programId: params.selectedProgram,
      menteeId: mentee?.participantId,
    }).then((res) => {
      setLoading(false);
      setMatchedMentors(res.data);
    });
  };
  useEffect(() => {
    getMatchedMentors();
  }, []);
  return (
    <>
      {mentee && (
        <Modal
          onClose={() => {
            closeModal(false);
          }}
          title={"Assign Mentee"}
          isButtonCenter={true}
          isNotRound={true}
          isTask={true}
          variant={"transparent"}
          actions={[
            {
              text: "Cancel",
              onClick: () => {
                closeModal(false);
              },
            },
          ]}
        >
          <MenteeInfoContainer>
            <MenteeImage>
              <Image
                src={
                  mentee.participant.image
                    ? mentee.participant.image
                    : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                }
              ></Image>
            </MenteeImage>
            <MenteeInfo>
              <MenteeName>
                {mentee.participant.firstName} {mentee.participant.lastName}
              </MenteeName>
              <MenteeRole>{mentee.joinAs}</MenteeRole>
            </MenteeInfo>
          </MenteeInfoContainer>
          <Suggestions>
            <HeadText>Suggested</HeadText>
            <MatchMakingSliderOuter
              isCenter={!loading && matchedMentors && matchedMentors.length === 0}
            >
              {loading ? (
                <Loading loadingItem="Mentors"/>
              ) : matchedMentors && matchedMentors.length > 0 ? (
                <MatchMakingSlider successModal={successModal} setSuccessModal={setSuccessModal} closeModal={closeModal} matchModal={matchModal} setMatchModal={setMatchModal} matchedParticipants={matchedParticipants} mentee={mentee} matchedMentors={matchedMentors} setMatchedParticipants={setMatchedParticipants} />
              ) : (
                <NoMatchContainer>
                  <NoMatchedText>No suggestions for this mentee.</NoMatchedText>
                </NoMatchContainer>
              )}
            </MatchMakingSliderOuter>
            <IgnoreSuggestion
              onClick={() => {
                closeModal(false);
                setClickedMentee(mentee);
                setOpenReassignModal(mentee.participantId);
              }}
            >
              <IgnoreText>Ignore suggestion</IgnoreText>
              <Icon type={"arrow-forward"} />
            </IgnoreSuggestion>
          </Suggestions>
        </Modal>
      )}
    </>
  );
};

export default MatchMaking;
